import { render, staticRenderFns } from "./PostResponse.vue?vue&type=template&id=34a05681&"
import script from "./PostResponse.vue?vue&type=script&lang=js&"
export * from "./PostResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports